import analyticsWrapper from 'helpers/analytics/analyticsWrapper';

export function fireGAEvent(label, screenName) {
  if (typeof window === 'undefined') {
    return;
  }
  const isMobile = !!(
    typeof window !== 'undefined' &&
    window.App &&
    window.App.state &&
    window.App.state.isMobile
  );
  const category = isMobile ? 'WAP_Login' : 'WEB_Login';
  const gaLabel = `${label}-${window.location.pathname}`;
  analyticsWrapper('gaAndGrx', 'send', 'event', category, screenName, gaLabel);
}

export default fireGAEvent;
